/**
 * https://www.npmjs.com/package/react-multi-select-component
 */
import { Option } from "react-multi-select-component";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

export type FormMultiSelectProps<T> = FormItemProps<string> & {
  options: T[];
  optionKey: (t: T) => string;
  optionLabel: (t: T) => string;
  disabled?: boolean;
  value?: T;
  onChange: (value: T) => void;
};

const getOption = <T,>(args: {
  option: T;
  optionKey: (t: T) => string;
  optionLabel: (t: T) => string;
}): Option => {
  return {
    value: args.optionKey(args.option),
    label: args.optionLabel(args.option),
    key: args.optionKey(args.option),
  };
};

const getOptions = <T,>(props: FormMultiSelectProps<T>): Option[] => {
  return props.options.map((option) => {
    return getOption({ ...props, option });
  });
};

const getValue = <T,>(props: FormMultiSelectProps<T>): string | undefined => {
  if (!props.value) return;
  return props.optionKey(props.value);
};

const getSelection = <T,>(props: FormMultiSelectProps<T>, value: string): T | undefined => {
  if (!value) return;
  return props.options.find((o) => props.optionKey(o) === value);
};

export const FormSingleSelect = <T,>(props: FormMultiSelectProps<T>) => {
  const renderEmptyOption = () => {
    if (props.value) return null;
    return <option value={undefined}></option>;
  };

  return (
    <FormItemContainer<string> {...props}>
      <select
        value={getValue(props)}
        onChange={(e) => {
          const selection = getSelection(props, e.target.value);
          if (!selection) return;
          props.onChange(selection);
        }}
      >
        {renderEmptyOption()}
        {getOptions(props).map((option) => (
          <option value={option.value} key={option.key}>
            {option.label}
          </option>
        ))}
      </select>
    </FormItemContainer>
  );
};
